export default "__VITE_ASSET__mG1ACPAM__"